'use strict';

class AccountBasic {
  constructor($route, originatorService, commonService, I18N, Notification, validationService) {
    this.$route = $route;
    this.originatorService = originatorService;
    this.commonService = commonService;
    this.I18N = I18N;
    this.Notification = Notification;
    this.validationService = validationService;
  }

  $onInit() {
    this.sendRegningContactEmail = '';

    this.originator = {
      bankAccount : {
        additionalBankAccounts: []
      }
    };

    this.load();

    $('select.custom-select').each(function () {
      new Select({ // eslint-disable-line
        el: this
      });
    });
  }

  load() {
    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
        //DELETE old deprecated property
        delete (this.originator.bankAccount.additionalNumbers);
        this.originatorService.settings()
          .then((r) => {
            this.sendRegningContactEmail = r.data.sendRegningContactEmail;
          });
      });
  }

  lookup(zip) {
    if (zip && this.originator.contact.address.country === 'NORGE') {
      if (zip.length === 4) {
        this.commonService.getCityByPostCode(zip)
          .then((resp) => {
            this.originator.contact.address.city = resp.data.city ? resp.data.city : 'OLSO';
          });
      }
    }
  }

  deleteLogo() {
    this.originatorService.deleteLogo()
      .then(() => this.$route.reload());
  }

  removeAdditionalAccount(index) {
    this.originator.bankAccount.additionalBankAccounts.splice(index, 1);
  }

  addAdditionalAccount() {
    this.originator.bankAccount.additionalBankAccounts.push(null);
  }

  save() {
    this.validationService.cleanupErrors();
    $('input').removeClass('error');
    $('input').removeClass('ng-invalid');
    $('label').removeClass('error');
    $('div.alert-box').remove();
    $('div.alert-box').each(() => {
      $(this).remove();
    });

    angular.extend(this.originator, {
      sendRegningContactEmail: this.sendRegningContactEmail
    });

    console.log(this.originator);

    this.originatorService.update(this.originator)
      .then(() => {
        this.load();
        this.Notification.success(this.I18N.user.saved);
      })
      .catch((err) => {
        if (err) {
          this.Notification.error('Oppdatering mislyktes.');

          this.validationService.cleanupErrors();
          this.validationService.listErrors(err.data.errors);

          if (!err.data.errors || !err.data.errors.length) {
            this.Notification.error(err.data.endUserMessage);
          }
        }
      });
  }
}

AccountBasic.$inject = ['$route', 'originatorService', 'commonService', 'I18N', 'Notification', 'validationService'];

const accountBasic = {
  bindings: {
    countries: '<',
    organisationForms: '<'
  },
  controller: AccountBasic,
  templateUrl: 'account/basic.html'
};

angular
  .module('SendRegning')
  .component('accountBasic', accountBasic)
  .config(($routeProvider) => {
    $routeProvider
      .when('/konto', {
        title: 'Konto',
        template: '<account-basic countries="$resolve.countries" organisation-forms="$resolve.organisationForms" />',
        resolve: {
          countries: (commonService) => commonService.getCountries(),
          organisationForms: (commonService) => commonService.getOrganisationForms()
        },
        secure: true
      });
  });
